/**
 * Holds all tbid constants for maintainability and re-use between sub-modules
 **/
type TbidConstants = {
    AUTH_PATH: string;
    LOGOUT_PATH: string;
    USER_PATH: string;
    LOGIN_METHODS_PATH: string;
    LOGIN_V2_PATH: string;
    UPDATE_PROFILE_PATH: string;
    VIOLATION_PATH: string;
    REMEDIATE_PATH: string;
    EDO_STATUS_PATH: string;
    IIS_SESSION_STORAGE_KEY: string;
    USE_SESSION_STORAGE: boolean;
    SESSION_STORAGE_TTL: number;
    IIS_DISABLED_ERROR_MESSAGE: string;
    IIS_DEV_COOKIE: string;
    IIS_QA_COOKIE: string;
    IIS_STAGE_COOKIE: string;
    IIS_PERF_COOKIE: string;
    IIS_PRODUCTION_COOKIE: string;
    IIS_HOTFIX_COOKIE: string;
    IIS_DEV_DOMAIN_HOST: string;
    IIS_QA_DOMAIN_HOST: string;
    IIS_PERF_DOMAIN_HOST: string;
    IIS_STAGE_DOMAIN_HOST: string;
    IIS_PROD_DOMAIN_HOST: string;
    IIS_HOTFIX_DOMAIN_HOST: string;
    PROFILE_PATH: string;
    SETTINGS_PATH: string;
    PARAM_LOGGED_OUT: string;
    PARAM_METHOD: string;
    PARAM_REFERRER: string;
    NEW_SESSION_TRACKED_ANALYTICS: string;
    PARAM_SIGN_UP: string;
    PARAM_LOGGED_IN: string;
    PARAM_PROGRESSIVE: string;
    GLOBAL_EVENT_NAME: string;
};
export const {
    AUTH_PATH,
    LOGOUT_PATH,
    USER_PATH,
    LOGIN_METHODS_PATH,
    LOGIN_V2_PATH,
    UPDATE_PROFILE_PATH,
    VIOLATION_PATH,
    REMEDIATE_PATH,
    EDO_STATUS_PATH,
    IIS_SESSION_STORAGE_KEY,
    USE_SESSION_STORAGE,
    SESSION_STORAGE_TTL,
    IIS_DISABLED_ERROR_MESSAGE,
    IIS_DEV_COOKIE,
    IIS_QA_COOKIE,
    IIS_STAGE_COOKIE,
    IIS_PERF_COOKIE,
    IIS_PRODUCTION_COOKIE,
    IIS_HOTFIX_COOKIE,
    IIS_DEV_DOMAIN_HOST,
    IIS_QA_DOMAIN_HOST,
    IIS_PERF_DOMAIN_HOST,
    IIS_STAGE_DOMAIN_HOST,
    IIS_PROD_DOMAIN_HOST,
    IIS_HOTFIX_DOMAIN_HOST,
    PROFILE_PATH,
    SETTINGS_PATH,
    PARAM_LOGGED_OUT,
    PARAM_METHOD,
    PARAM_REFERRER,
    NEW_SESSION_TRACKED_ANALYTICS,
    PARAM_SIGN_UP,
    PARAM_LOGGED_IN,
    PARAM_PROGRESSIVE,
    GLOBAL_EVENT_NAME,
}: TbidConstants = {
    AUTH_PATH: '/services/auth/login',
    LOGOUT_PATH: '/services/auth/logout',
    LOGIN_V2_PATH: '/services/auth/v2/login',
    USER_PATH: '/services/api/user',
    LOGIN_METHODS_PATH: '/services/auth/loginmethods',
    UPDATE_PROFILE_PATH: '/services/app/p/c/v1/userprofile',
    VIOLATION_PATH: '/services/auth/violations',
    REMEDIATE_PATH: '/services/auth/remediate',
    EDO_STATUS_PATH: '/services/api/edo/user/status',
    IIS_SESSION_STORAGE_KEY: 'iis_data',
    USE_SESSION_STORAGE: true,
    SESSION_STORAGE_TTL: 30 * 60 * 1000, // ttl is 30 mins converted to milliseconds
    IIS_DISABLED_ERROR_MESSAGE: 'Authentication disabled: system down',
    IIS_DEV_COOKIE: 'iis_dt',
    IIS_QA_COOKIE: 'iis_qt',
    IIS_STAGE_COOKIE: 'iis_st',
    IIS_PERF_COOKIE: 'iis_pft',
    IIS_PRODUCTION_COOKIE: 'iis_pt',
    IIS_HOTFIX_COOKIE: 'iis_ht',
    IIS_DEV_DOMAIN_HOST: 'https://iis-dev.digital.salesforce.com',
    IIS_QA_DOMAIN_HOST: 'https://iis-qa.digital.salesforce.com',
    IIS_PERF_DOMAIN_HOST: 'https://iis-perf.digital.salesforce.com',
    IIS_STAGE_DOMAIN_HOST: 'https://iis-stage.digital.salesforce.com',
    IIS_PROD_DOMAIN_HOST: 'https://iis.digital.salesforce.com',
    IIS_HOTFIX_DOMAIN_HOST: 'https://iis-hotfix.digital.salesforce.com',
    PROFILE_PATH: '/trailblazer/profile',
    SETTINGS_PATH: '/trailblazer/settings',
    PARAM_LOGGED_OUT: 'hasLoggedOut',
    PARAM_METHOD: 'method',
    PARAM_REFERRER: 'referrer',
    NEW_SESSION_TRACKED_ANALYTICS: 'isLoginTracked',
    PARAM_SIGN_UP: 'signup',
    PARAM_LOGGED_IN: 'hasLoggedIn',
    PARAM_PROGRESSIVE: 'progressive',
    GLOBAL_EVENT_NAME: 'www_track',
};
